import React from 'react';
import { Typography, List, ListItem, ListItemText, Divider, Link } from '@mui/material';

const PrivacyPolicyUpdate: React.FC = () => {
  return (
    <div>
      <Typography variant="h4" gutterBottom>
        12. Atualização da Política de Privacidade
      </Typography>

      <Typography paragraph>
        A INNOVA PLANO DE SAÚDE LTDA reserva-se o direito de alterar esta Política de Privacidade a qualquer tempo, visando garantir sua conformidade com eventuais modificações realizadas em seu site, aplicativos, serviços ou em razão de alterações legislativas, regulatórias ou normativas aplicáveis.
      </Typography>

      <Typography paragraph>
        Recomenda-se que o titular dos dados revise periodicamente esta Política para se manter informado sobre possíveis alterações. As eventuais modificações entrarão em vigor a partir da data de sua publicação no site oficial da INNOVA PLANO DE SAÚDE, sendo o titular notificado sobre as mudanças realizadas, conforme previsto na legislação vigente.
      </Typography>

      <Typography paragraph>
        Ao continuar utilizando os serviços da INNOVA PLANO DE SAÚDE e fornecendo seus dados pessoais após a implementação das alterações, o titular manifesta sua concordância com os novos termos da Política de Privacidade.
      </Typography>

      <Divider sx={{ my: 3 }} />

      {/* Seção de Encarregado de Proteção de Dados */}
      <Typography variant="h4" gutterBottom>
        13. Encarregado de Proteção de Dados
      </Typography>

      <Typography paragraph>
        A INNOVA PLANO DE SAÚDE nomeou dois profissionais como Encarregados de Proteção de Dados Pessoais ou Data Protection Officer (DPO) para a gestão da LGPD:
      </Typography>

      <List>
        <ListItem>
          <ListItemText primary="Responsáveis: INNOVA PLANO DE SAÚDE LTDA" />
        </ListItem>
        <ListItem>
          <ListItemText
            primary={
              <Typography variant="body1">
                O Usuário pode entrar em contato com um dos DPO’s no seguinte endereço eletrônico:{' '}
                <Link href="mailto:dpo@innovaplanodesaude.com.br" target="_blank" rel="noopener noreferrer">
                  dpo@innovaplanodesaude.com.br
                </Link>
              </Typography>
            }
          />
        </ListItem>
      </List>
    </div>
  );
};

export default PrivacyPolicyUpdate;
